import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface MeterEvent {
  updatedAt: string;
  updateType: 'consumption_data' | 'status';
  processName: string;
  transmittedAt: string | null;
  dataStart: string | null;
  dataEnd: string | null;
  success: boolean;
  errorMessage: string | null;
}

interface MeterEventsResponse {
  events: MeterEvent[];
}

export function useMeterEvents(
  sensorId: string | undefined,
  dateRange?: { from: Date; to: Date },
) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-events', sensorId, dateRange?.from, dateRange?.to],
    queryFn: () => {
      const params = dateRange
        ? `?start=${dateRange.from.toISOString()}&end=${dateRange.to.toISOString()}`
        : '';
      return apiClient.get<MeterEventsResponse>(`meters/${sensorId}/events${params}`);
    },
    enabled: !!sensorId,
  });
}
